import { JsonObject, JsonProperty } from 'json2typescript';

import { OrderType, OrderTypeAvailableInterface } from '../../../core';
import { OrderTypeAdapter } from '../../client/helpers/serializer/adapters/order-type.adapter';
import { StringAdapter } from '../../client/helpers/serializer/adapters/string.adapter';

@JsonObject('OrderTypeAvailable')
export class OrderTypeAvailable implements OrderTypeAvailableInterface {
    @JsonProperty('CodeType', OrderTypeAdapter, true)
    private _type: OrderType = undefined;

    @JsonProperty('Description', StringAdapter, true)
    private _description: string = undefined;

    @JsonProperty('Available', Boolean, true)
    private _available: boolean = undefined;

    constructor(type?: OrderType) {
        this._type = type;
        this._available = true;
    }

    get type(): OrderType {
        return this._type;
    }

    get description(): string {
        return this._description;
    }

    get available(): boolean {
        return this._available;
    }
}
